<template>
  <div class="swiper-main-container" ref="parentMovingRef" @mousemove="handleParentMoving">
    <div class="banner-container">
      <div class="bg-wrap" :class="{ 'm-bg-wrap': isMobile }" ref="movingRef" :key="info.id">
        <img style="z-index: 1" :src="isMobile ? info.image_mobile : info.image" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import responsiveMixin from "@/mixins/responsive";

const multiple = 800;

export default {
  name: "FireBanner",
  mixins: [responsiveMixin],
  components: {  },
  data() {
    return {
      parentMoving: null,
      moving: null
    };
  },
  props: {
    info: {
      type: Object,
      default: () => { }
    },
    slide: {
      type: Number,
      default: 0
    }
  },
  mounted() {
    this.movingBg();
  },
  beforeDestroy() {
    this.parentMoving.removeEventListener("mousemove", this.handleParentMoving);
  },
  methods: {
    movingBg() {
      this.parentMoving = this.$refs.parentMovingRef;
      this.moving = this.$refs.movingRef;
      this.parentMoving.addEventListener("mousemove", this.handleParentMoving);
    },

    transformElement(x, y) {
      let box = this.moving.getBoundingClientRect();
      const percentage = x / window.outerWidth;
      this.moving.style.setProperty("--percentage", percentage);
      let calcX = -(y - box.y - (box.height / 2)) / multiple;
      let calcY = (x - box.x - (box.width / 2)) / multiple;
      this.moving.style.transform = "rotateX(" + calcX + "deg) " + "rotateY(" + calcY + "deg)";
    },

    handleParentMoving(e) {
      if (!this.isMobile) {
        requestAnimationFrame(() => {
          this.transformElement(e.clientX, e.clientY);
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./item.scss";
</style>
